import tenantLogo from '../assets/images/openfleet-logo.png';
import pinSmallMap from '../assets/images/custom/openfleet/openfleet-pin-small.svg';
import pinBigMap from '../assets/images/custom/openfleet/openfleet-pin-big.svg';
import favicon from '../assets/images/custom/openfleet/favicon.png';

const ios = {
  tenant: {
    name: 'IOS',
    politique_de_confidentialite_url:
      'https://www.ioscv.co.uk/carshare-privacy-policy',
    assets: {
      favicon: favicon,
      logo: tenantLogo,
      pinSmallMap: pinSmallMap,
      pinBigMap: pinBigMap
    }
  },
  typography: {
    fontFamily: [
      'SofiaPro',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ].join(',')
  },
  palette: {
    primary: {
      light: '#45aab6',
      main: '#45aab6',
      dark: '#45aab6'
    },
    secondary: {
      main: '#8eb934'
    },
    background: {
      default: '#ffffff'
    }
  }
};

export default ios;
